module.exports = __webpack_public_path__ + "static/media/bottlings15.87b5ef0b.jpg";